import React, { useCallback } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Link from "../../../Link";
import { MenuChild as MenuChildProps } from "../../../../interfaces/common";

const MenuChild: React.FC<MenuChildProps> = ({
  text, redirectsTo
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const active = redirectsTo && pathname.includes(redirectsTo);

  const handleMenuChildClick = useCallback(() => {
    redirectsTo && navigate(redirectsTo);
  }, [navigate]);

  return (
    <li key={text} className={`menu-item ${active ? "active" : ""}`}>
      <Link
        className="cursor-pointer menu-link"
        text={text}
        href={redirectsTo || '#'}
        onClick={handleMenuChildClick}
      />
    </li>
  );
};

export default MenuChild;
